// /mnt/mantenimientos/frontend/src/modules/registry.js

import DashboardSupervisorModule from "./DashboardSupervisorModule";
import MantenimientosModule from "./MantenimientosModule";
import MonitorizacionModule from "./MonitorizacionModule";
import EquiposModule from "./EquiposWorkspaceModule";
import BackupTasksModule from "./BackupTasksModule";
import WorkQueueModule from "./WorkQueueModule";

import ClientesTab from "../components/ClientesTab";
import UsuariosTab from "../components/UsuariosTab";
import InformesTab from "../components/InformesTab";
import CredencialesTab from "../components/CredencialesTab";
import AgentsModule from "./AgentsModule";
import AvisosModule from "./AvisosModule";
import RemoteAccessModule from "./RemoteAccessModule";

import { MODULE_IDS } from "./moduleIds";

export const MODULES_REGISTRY = [
  {
    id: MODULE_IDS.WORK_QUEUE,
    title: "Mi trabajo",
    icon: "✅",
    hint: "Pendientes del mes",
    roles: ["tecnico"],
    section: "global",
    order: 5,
    requiresCliente: false,
    component: WorkQueueModule,
  },
  // =========================
  // GLOBAL / SUPERVISOR-ADMIN
  // =========================
  {
    id: MODULE_IDS.DASHBOARD_SUPERVISOR,
    title: "Dashboard",
    icon: "📊",
    hint: "Vista global",
    roles: ["supervisor", "admin"],
    section: "global",
    order: 10,
    requiresCliente: false,
    component: DashboardSupervisorModule,
  },
  {
    id: MODULE_IDS.INFORMES,
    title: "Informes",
    icon: "📄",
    hint: "PDFs y reportes",
    roles: ["supervisor", "admin"],
    section: "global",
    order: 30,
    requiresCliente: false,
    component: InformesTab,
  },
  {
    id: MODULE_IDS.CLIENTES,
    title: "Clientes",
    icon: "👥",
    hint: "Gestión de clientes",
    roles: ["supervisor", "admin"],
    section: "global",
    order: 40,
    requiresCliente: false,
    workspace: true,
    component: ClientesTab,
  },
  {
    id: MODULE_IDS.USUARIOS,
    title: "Usuarios",
    icon: "🧑‍💼",
    hint: "Gestión de usuarios",
    roles: ["supervisor", "admin"],
    section: "global",
    order: 50,
    requiresCliente: false,
    workspace: true,
    component: UsuariosTab,
  },
  {
    id: MODULE_IDS.CREDENCIALES,
    title: "Credenciales",
    icon: "🔑",
    hint: "Secretos",
    // La concesión individual determina qué supervisores pueden verla.
    roles: ["supervisor", "admin"],
    section: "global",
    order: 60,
    // Although its entry lives in the global sidebar, credentials always
    // belong to the client selected in the top bar.
    requiresCliente: true,
    workspace: true,
    component: CredencialesTab,
    componentProps: ({ clienteSeleccionadoId, clienteInfo, ordenadores }) => ({
      clienteId: clienteSeleccionadoId ?? clienteInfo?.id ?? null,
      clienteNombre: clienteInfo?.nombre || "",
      ordenadores: ordenadores || [],
    }),
  },
  {
    id: MODULE_IDS.PFSENSE_AGENTS,
    title: "Agentes",
    icon: "🤖",
    hint: "Alta, instalación y asociación de agentes",
    roles: ["supervisor", "admin"],
    section: "global",
    order: 65,
    requiresCliente: false,
    workspace: true,
    component: AgentsModule,
  },
  {
    id: MODULE_IDS.INTEGRATIONS,
    title: "Integraciones",
    icon: "🔌",
    hint: "Conectores globales y calendarios compartidos",
    roles: ["tecnico", "supervisor", "admin"],
    section: "global",
    order: 66,
    requiresCliente: false,
    workspace: true,
    component: AgentsModule,
    componentProps: () => ({ variant: "integrations" }),
  },

  // =========================
  // POR CLIENTE
  // =========================
  {
    id: MODULE_IDS.DASHBOARD,
    title: "Inicio",
    icon: "📊",
    hint: "Panel operativo",
    roles: ["tecnico", "supervisor", "admin"],
    section: "global",
    order: 1,
    requiresCliente: false,
    component: DashboardSupervisorModule,
  },
  { id: MODULE_IDS.AVISOS, title: "Avisos", icon: "📬", hint: "Avisos de Informática", roles: ["tecnico","supervisor","admin"], section: "cliente", order: 105, requiresCliente: false, supportsGlobalContext: true, workspace: true, component: AvisosModule },
  {
    id: MODULE_IDS.MANTENIMIENTOS,
    title: "Mantenimientos",
    icon: "🧰",
    hint: "Control y seguimiento",
    roles: ["tecnico", "supervisor", "admin"],
    section: "cliente",
    order: 110,
    requiresCliente: true,
    supportsGlobalContext: true,
    component: MantenimientosModule,
  },
  {
    id: MODULE_IDS.MONITORIZACION,
    // Alias de transición: no se muestra en la navegación.
    title: "Monitorización",
    icon: "📡",
    hint: "Telemetría nativa Megaprint",
    roles: ["tecnico", "supervisor", "admin"],
    section: "cliente",
    order: 120,
    requiresCliente: true,
    workspace: true,
    clientHeaderVariant: "compact",
    component: MonitorizacionModule,
  },
  {
    id: MODULE_IDS.EQUIPOS,
    title: "Equipos",
    icon: "💻",
    hint: "Listado de máquinas",
    roles: ["tecnico", "supervisor", "admin"],
    section: "cliente",
    order: 140,
    requiresCliente: true,
    workspace: true,
    clientHeaderVariant: "compact",
    supportsGlobalContext: true,
    component: EquiposModule,
  },
  {
    id: MODULE_IDS.REMOTE_ACCESS,
    title: "Remoto",
    icon: "🖧",
    hint: "Equipos Managed autorizados",
    roles: ["tecnico", "supervisor", "admin"],
    section: "cliente",
    order: 145,
    requiresCliente: false,
    supportsGlobalContext: true,
    workspace: true,
    clientHeaderVariant: "compact",
    component: RemoteAccessModule,
  },
  {
    id: MODULE_IDS.BACKUPS_NEW,
    title: "Copias Megaprint",
    icon: "🗄️",
    hint: "Agentes y tareas propias",
    roles: ["supervisor", "admin"],
    section: "cliente",
    order: 135,
    requiresCliente: true,
    workspace: true,
    clientHeaderVariant: "compact",
    component: BackupTasksModule,
  },
];
